import SSOContainer from './SSO'

export default SSOContainer
